import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import logo from "../images/logo.png";

function Count() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    var countSap = 0;
    var countAll = 0;

    var users = db.collection("users");

    var getCount = () => {
      users.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          var data = doc.data();

          if (
            data["email"].includes("@sap.com") &&
            !data["email"].includes("test") &&
            !data["consent"] == false
          ) {
            countSap += 1;
          }
          countAll += 1;
        });

        console.log({ countAll, countSap });
        setCount(countSap);
      });
    };
    getCount();
  }, []);

  // const handleClick = () => {

  // };
  return (
    <div className="cmn-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="text-center">
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <p style={{ color: "yellow", fontSize: "20px" }}>TOTAL COUNT</p>
              <div
                className="registration-count"
                style={{ fontSize: "100px", color: "yellow" }}
              >
                <CountUp start={0} end={count} duration={2.75} delay={0} />
              </div>
              <p style={{ color: "yellow", fontSize: "20px" }}>
                USERS REGISTERED
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Count;
